import React, { memo } from 'react';
import { Skeleton, Tag } from 'gatorcomponents';
import useServerStatus from '@/hooks/useServerStatus';
import useStatusFormatter from '@/hooks/useStatusFormatter';

const ServerStatus = memo(({
  serverInfo,
  serverId,
}) => {
  const isLocked = serverInfo?.locked;
  const isLockedStatus = serverInfo?.reason;

  const { status: fetchedStatus, loadingStatus: fetchedLoadingStatus } = useServerStatus(
    serverId,
    { autoFetch: !isLocked },
  );

  const statusLabel = useStatusFormatter(isLockedStatus);

  const status = isLocked ? statusLabel : fetchedStatus;
  const loadingStatus = isLocked ? false : fetchedLoadingStatus;

  if (loadingStatus) {
    return <Skeleton width="80px" height="32px" />;
  }

  return status ? <Tag label={status.value} variant={status.variant} size="md" /> : null;
});

ServerStatus.displayName = 'ServerStatus';

export default ServerStatus;
